import {
	Alert,
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Stack,
	Typography,
} from "@mui/material";
import { ClearRounded } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { grey } from "@mui/material/colors";
import { useMemo } from "react";

const BulkPublishModal = ({
	modal,
	setModal,
	previewColors = [],
	publishCount = 0,
	truncated = false,
	selectAllFiltered = false,
	filterSummary = "",
	loading = false,
	onConfirm,
}) => {
	const columns = useMemo(
		() => [
			{ field: "option_id", headerName: "Option ID", width: 140, headerAlign: "center", align: "center" },
			{ field: "style_id", headerName: "Style ID", width: 130, headerAlign: "center", align: "center" },
			{ field: "style_name", headerName: "Style Name", width: 160, headerAlign: "center", align: "center" },
			{ field: "color", headerName: "Color", width: 120, headerAlign: "center", align: "center" },
			{ field: "stage", headerName: "Stage", width: 110, headerAlign: "center", align: "center" },
			{ field: "total_qty", headerName: "Total Qty", width: 110, headerAlign: "center", align: "center" },
			{ field: "buy_qty_status", headerName: "Buy Qty Status", width: 140, headerAlign: "center", align: "center" },
		],
		[],
	);

	const handleClose = () => {
		if (loading) return;
		setModal(false);
	};

	return (
		<Dialog open={modal} onClose={handleClose} maxWidth="lg" fullWidth>
			<DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
				<Typography variant="h6">Confirm Bulk Publish</Typography>
				<IconButton onClick={handleClose} disabled={loading}>
					<ClearRounded />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Stack spacing={1.5}>
					<Alert severity="info">
						{selectAllFiltered
							? `Publishing all ${publishCount} BUYING color(s) with total qty > 0 matching the current filter${
									filterSummary ? `: ${filterSummary}` : ""
							  }.`
							: `Publishing ${publishCount} selected color(s) in BUYING stage with total qty > 0.`}
					</Alert>
					{truncated && (
						<Alert severity="warning">Showing the first {previewColors.length} of {publishCount} color(s).</Alert>
					)}
					<Box height="45vh">
						<DataGrid
							rows={previewColors}
							columns={columns}
							getRowId={(row) => row.option_id}
							hideFooter
							disableColumnSelector
							disableRowSelectionOnClick
							sx={{
								border: "none",
								"& .MuiDataGrid-columnHeaders": {
									background: grey[300],
									borderRadius: 1,
								},
							}}
						/>
					</Box>
				</Stack>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button variant="outlined" onClick={handleClose} disabled={loading}>
					Cancel
				</Button>
				<Button
					variant="contained"
					color="success"
					onClick={onConfirm}
					disabled={loading || publishCount === 0}>
					Confirm Publish ({publishCount})
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default BulkPublishModal;
